import React from 'react'

import Hbs from '../components/Hbs'

const Cta = () => (
  <section className="bg-light" id="cta">
    <div className="container">
      <div className="cta-content">
        <h3 className="text-gray">Stay connected with Farmhand.</h3>
        <h5 className="text-gray">Let us help you get in-tune with your growing operation. Get in touch with us to get started.</h5>
      </div>
      <Hbs />
    </div>
  </section>
)

export default Cta



// WEBPACK FOOTER //
// ./containers/Cta.js